export const FLOW_STEP_STATUS = {
  INCOMPLETE: 'incomplete',
  FORM_VALID: 'form_valid',
  FORM_SUBMITTED: 'form_submitted',
  ERROR: 'error',
  COMPLETE: 'complete',
  EDITING: 'edit'
}
